import { Navigate, Route, Routes } from 'react-router'
import { HomePage } from './pages/HomePage'

export function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      {/* The catalog is not a route — it is the PDF itself, opened in a new tab straight from
          public/. Anything else, including the old /catalog path, lands back on the homepage. */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
